import { Controller } from "@hotwired/stimulus";

// A closed <details> does not stop the browser from fetching the images inside it,
// so the address stays off the element until the disclosure opens.
export default class extends Controller {
  static targets = ["image"];
  static values = { src: String };

  load() {
    if (!this.element.open || this.imageTarget.getAttribute("src")) return;

    this.imageTarget.src = this.srcValue;
  }
}
